import { Map } from 'immutable';

import {
  FETCH_CONTRACT_COMMISIONINGS_REQUEST,
  FETCH_CONTRACT_COMMISIONINGS_SUCCESS,
  FETCH_CONTRACT_COMMISIONINGS_FAILURE,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === FETCH_CONTRACT_COMMISIONINGS_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === FETCH_CONTRACT_COMMISIONINGS_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === FETCH_CONTRACT_COMMISIONINGS_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
